import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { createStyles } from '@mantine/styles';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var useStyles = createStyles(function (theme, _ref, getRef) {
  var transitionDuration = _ref.transitionDuration,
      disableIconRotation = _ref.disableIconRotation,
      iconPosition = _ref.iconPosition,
      offsetIcon = _ref.offsetIcon,
      iconSize = _ref.iconSize;
  var icon = getRef("icon");
  return {
    icon: {
      ref: icon,
      transition: "transform ".concat(transitionDuration, "ms ease"),
      marginRight: iconPosition === "right" ? 0 : theme.spacing.sm,
      marginLeft: iconPosition === "right" ? theme.spacing.lg : 0,
      width: iconSize,
      minWidth: iconSize
    },
    label: {
      color: "inherit",
      fontWeight: 500,
      flex: 1,
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    item: {
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      borderBottom: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3])
    },
    itemOpened: _defineProperty({}, "& .".concat(icon), {
      transform: disableIconRotation ? "none" : "rotate(180deg)"
    }),
    itemTitle: {
      margin: 0,
      padding: 0,
      fontWeight: "normal"
    },
    control: __spreadProps(__spreadValues(__spreadValues({}, theme.fn.focusStyles()), theme.fn.fontStyles()), {
      width: "100%",
      display: "flex",
      alignItems: "center",
      flexDirection: iconPosition === "right" ? "row-reverse" : "row",
      padding: "".concat(theme.spacing.md, "px ").concat(theme.spacing.md / 2, "px"),
      paddingLeft: iconPosition === "right" ? theme.spacing.sm + 4 : null,
      fontWeight: 500,
      textAlign: "left",
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      "&:hover": {
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
      }
    }),
    content: __spreadProps(__spreadValues({}, theme.fn.fontStyles()), {
      wordBreak: "break-word",
      lineHeight: theme.lineHeight,
      paddingLeft: iconPosition === "right" ? 0 : offsetIcon ? iconSize + theme.spacing.xs / 2 : 0
    }),
    contentInner: {
      padding: theme.spacing.md,
      paddingTop: theme.spacing.xs / 2
    }
  };
});
export default useStyles;